// extracted by mini-css-extract-plugin
export default {"expiredIcon":"ExpiredIcon_expiredIcon__fHM8+"};